export const subscriptionDetailsRoute = (orderId = ':orderId') => `/subscriptions/${orderId}`
